import type { Breadcrumb } from "@/common/types/types";
import { AppSidebar } from "./AppSidebar";
import { Container } from "./container";
import { Navbar } from "./navbar";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import { Toaster } from "@/components/ui/toast/toaster";
import { useFeedback } from "@/hooks/use-feedback";

interface LayoutProps {
  children: React.ReactNode;
  navbarTitle: string;
  breadcrumbs?: Breadcrumb[];
  icon?: React.ReactNode;
  iconHandler?: () => void;
  isLoading?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  navbarTitle,
  breadcrumbs = [],
  icon,
  iconHandler,
  isLoading = false,
}) => {
  useFeedback();

  return (
    <div className="layout flex h-screen w-full">
      <AppSidebar />
      <div className="flex flex-col flex-1 overflow-hidden">
        <Navbar
          breadcrumbs={breadcrumbs}
          icon={icon}
          iconHandler={iconHandler}
          title={navbarTitle}
        />
        {isLoading ? (
          <div className="flex h-screen w-full">
            <LoadingSpinner className="m-auto" size={8} />
          </div>
        ) : (
          <Container>{children}</Container>
        )}
        <Toaster />
      </div>
    </div>
  );
};
